/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import { Route, Routes } from "react-router-dom";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import Layout from "./routes/Layout";
import RequireAuth from "./routes/RequireAuth";
import JobDetailPage from "./pages/JobListPage/JobDetailPage";
import { createTheme, ThemeProvider } from "@mui/material";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import JobApplyPage from "./pages/JobListPage/JobApplyPage";
import SusunanKeluargaPage from "./pages/ProfilePage/SusunanKeluargaPage/SusunanKeluargaPage";
import RiwayatPendidikanPage from "./pages/ProfilePage/RiwayatPendidikanPage/RiwayatPendidikanPage";
import RiwayatPekerjaanPage from "./pages/ProfilePage/RiwayatPekerjaanPage/RiwayatPekerjaanPage";
import ChangePasswordPage from "./pages/ProfilePage/ChangePasswordPage/ChangePasswordPage";
import DataPribadiPage from "./pages/ProfilePage/DataPribadiPage/DataPribadiPage";
import DivisiPage from "./pages/HRPage/DivisiPage/DivisiPage";
import PendidikanPage from "./pages/HRPage/PendidikanPage/PendidikanPage";
import JobPage from "./pages/HRPage/JobPage/JobPage";
import PertanyaanPage from "./pages/HRPage/PertanyaanPage/PertanyaanPage";
import KandidatPage from "./pages/HRPage/KandidatPage/KandidatPage";
import InterviewPage from "./pages/HRPage/KandidatPage/InterviewPage";
import UserState from "./recoil/UserState";
import { useRecoilValue, useResetRecoilState } from "recoil";
import TalentPoolPage from "./pages/HRPage/KandidatPage/TalentPoolPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage/ForgotPasswordPage";
import ForgotPasswordLayout from "./pages/ForgotPasswordPage/ForgotPasswordLayout";
import ProfileTabPage from "./pages/ProfilePage/ProfileTabPage";
// import ViewKandidatFilePage from "./pages/ViewFilePage/ViewKandidatFilePage";
import ViewUserFilePage from "./pages/ViewFilePage/ViewUserFilePage";
import HomePage from "./pages/Homepage/HomePage";
import AuthenticatePage from "./pages/AuthenticatePage";
import { TermsAndConditionPage } from "./pages/LegalPage/TermsAndConditionPage";
import { PrivacyPolicyPage } from "./pages/LegalPage/PrivacyPolicyPage";
import { useIdleTimer } from "react-idle-timer";
import { useEffect, useState } from "react";
import { eraseCookie } from "./utils/cookies";
import FotoProfileState from "./recoil/FotoProfileState";
import ProfileState from "./recoil/ProfileState";
import KandidatViewPage from "./pages/ViewFilePage/KandidatViewPage";
import { CookieModal } from "./pages/Components/CookieModal";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00ACED",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#00000",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: ["Poppins", "DM Sans"].join(","),
    button: {
      textTransform: "none",
    },
  },
});

function App() {
  const recoilValue = useRecoilValue(UserState);

  const removeRecoil = useResetRecoilState(UserState);
  const removeRecoilFoto = useResetRecoilState(FotoProfileState);
  const removeRecoilProfile = useResetRecoilState(ProfileState);
  const eraseAuthCookie = async () => {
    removeRecoilFoto();
    removeRecoilProfile();
    removeRecoil();
    eraseCookie("token");
  };
  const handleLogout = () => {
    eraseAuthCookie().then(() => {
      window.location.reload();
    });
  };

  const timeout = 1000000;
  const [isIdle, setIsIdle] = useState(false);

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => setIsIdle(true);

  const { reset } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });

  useEffect(() => {
    if (isIdle) {
      if (window.confirm("Idle Confirmed, Lanjutkan Sesi ?")) {
        reset();
      } else {
        handleLogout();
      }
    }
  }, [isIdle]);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* public */}
          <Route
            path="/"
            element={
              recoilValue?.ROLE === "Admin" ? <KandidatPage /> : <HomePage />
            }
          />
          <Route
            path="/Job/:JobID"
            element={
              recoilValue?.ROLE === "Admin" ? (
                <KandidatPage />
              ) : (
                <JobDetailPage />
              )
            }
          />
          <Route
            path="/Login"
            element={recoilValue ? <UnauthorizedPage /> : <LoginPage />}
          />
          <Route
            path="/Register"
            element={recoilValue ? <UnauthorizedPage /> : <RegisterPage />}
          />
          <Route
            path="/ForgotPassword/:token"
            element={
              recoilValue ? <UnauthorizedPage /> : <ForgotPasswordLayout />
            }
          />
          <Route
            path="/ForgotPassword"
            element={
              recoilValue ? <UnauthorizedPage /> : <ForgotPasswordPage />
            }
          />
          <Route
            path="/Authenticate/:token"
            element={recoilValue ? <UnauthorizedPage /> : <AuthenticatePage />}
          />
          <Route path="/Unauthorized" element={<UnauthorizedPage />} />

          <Route
            path="/Legal/TermsAndCondition"
            element={<TermsAndConditionPage />}
          />
          <Route path="/Legal/PrivacyPolicy" element={<PrivacyPolicyPage />} />

          <Route element={<RequireAuth role={["Admin"]} />}>
            <Route path="/Divisi" element={<DivisiPage />} />
            <Route path="/Pendidikan" element={<PendidikanPage />} />
            <Route path="/Kandidat" element={<KandidatPage />} />
            <Route path="/Interview" element={<InterviewPage />} />
            <Route path="/Pertanyaan" element={<PertanyaanPage />} />
            <Route path="/TalentPool" element={<TalentPoolPage />} />
            <Route path="/Job" element={<JobPage />} />
            <Route
              path="/KandidatFile/:KandidatID"
              element={<KandidatViewPage />}
            />
          </Route>

          <Route element={<RequireAuth role={["User"]} />}>
            <Route path="/Job/Apply/:JobID" element={<JobApplyPage />} />
            <Route path="/Profile" element={<ProfileTabPage />} />
            <Route
              path="/Profile/SusunanKeluarga"
              element={<SusunanKeluargaPage />}
            />
            <Route
              path="/Profile/RiwayatPendidikan"
              element={<RiwayatPendidikanPage />}
            />
            <Route
              path="/Profile/RiwayatPekerjaan"
              element={<RiwayatPekerjaanPage />}
            />
            <Route path="/Profile/DataPribadi" element={<DataPribadiPage />} />
            <Route path="/ChangePassword" element={<ChangePasswordPage />} />
            <Route path="/File/:FileID" element={<ViewUserFilePage />} />
          </Route>
        </Route>
      </Routes>
       <CookieModal />
    </ThemeProvider>
  );
}

export default App;
